import { captureMessage, captureException, configureScope } from '@sentry/browser'
import { Severity } from '@sentry/types'

export const logToSentry = (msg, severity = Severity.Log, extra = {}, exception = false) => {
  if (process.env.VUE_APP_SENTRY_DSN) {
    if (extra) {
      configureScope(scope => {
        Object.keys(extra).forEach(key => {
          scope.setExtra(key, extra[key])
        })
      })
    }
    if (exception) {
      captureException(msg)
    } else {
      captureMessage(msg, severity)
    }
  }
}

export const logWarning = (msg, extra = {}) => {
  logToSentry(msg, Severity.Warning, extra)
}

export const logError = (msg, extra = {}) => {
  logToSentry(msg, Severity.Error, extra)
}

export const logException = e => {
  logToSentry(e, Severity.Error, {}, true)
}
